import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { WifiOff } from 'lucide-react';

const OfflineAlert: React.FC = () => {
  const { t } = useTranslation();
  const [isOffline, setIsOffline] = useState(false);

  useEffect(() => {
    // Fonction pour mettre à jour l'état de connexion
    const handleStatusChange = () => {
      setIsOffline(!navigator.onLine);
    };

    // Vérifier l'état initial
    setIsOffline(!navigator.onLine);

    // Ajouter des écouteurs d'événements
    window.addEventListener('online', handleStatusChange);
    window.addEventListener('offline', handleStatusChange);

    // Nettoyer les écouteurs d'événements
    return () => {
      window.removeEventListener('online', handleStatusChange);
      window.removeEventListener('offline', handleStatusChange);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="offline-message">
      <div className="offline-message-container">
        <div className="offline-message-content">
          <div className="offline-indicator" />
          <WifiOff className="w-5 h-5 text-white" />
          <p className="text-white text-sm font-medium">
            {t('app.offlineMessage', 'Vous devez être en ligne pour utiliser cette application')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default OfflineAlert; 